export default function initFixedHeaderOnScroll() {
  if (window.matchMedia('(min-width: 992px)').matches) {
    const header = document.querySelector('.topbar-area');
    const headerHeight = header.offsetHeight;
    document.addEventListener('scroll', () => {
      if (window.scrollY > headerHeight) {
        header.classList.add('fixed-header');
      } else {
        header.classList.remove('fixed-header');
      }
    });
  }
}
